<template>
  <div class="img-wrap">
    <div class="img-content" v-for="(item, index) in photoList" :key="index">
      <el-image
        style="width: 100px; height: 100px; margin: 20px"
        :src="item.fileUrl"
        :preview-src-list="imgList"
      >
      </el-image>
      <span class="upload-time">{{ item.lastModified || '--' }}</span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: Array,
  },
  watch: {
    value() {
      const list = this.value || [];
      this.photoList = list;
      this.imgList = list.map((item) => item.fileUrl);
    },
  },
  data() {
    return {
      imgList: [],
      photoList: [],
    };
  },

};
</script>
<style scoped>
.img-wrap{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
   margin-bottom: 20px;
}
.img-content{
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.upload-time{
  font-size: 12px;
  color: #909399;
}
</style>
